export default __webpack_public_path__ + "static/media/to-pimp-a-butterfly.24fb799a.jpg";